import { render, staticRenderFns } from "./Alien.vue?vue&type=template&id=1c56cdbe&"
import script from "./Alien.vue?vue&type=script&lang=js&"
export * from "./Alien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports